import { api } from '@/lib/api';
import type { VendorModuleType } from '@/features/vendors/types';
import type {
  AgreementModuleOverview,
  AgreementVendorStatus,
  AgreementVersionWithCount,
  PublishAgreementInput,
  PublishAgreementResult,
} from './types';

export async function fetch_agreement_overview(): Promise<AgreementModuleOverview[]> {
  const res = await api.get<AgreementModuleOverview[]>('/admin/agreements');
  return res.data;
}

export async function publish_agreement(input: PublishAgreementInput): Promise<PublishAgreementResult> {
  const form = new FormData();
  form.append('module_type', input.module_type);
  if (input.effective_from) form.append('effective_from', input.effective_from);
  if (input.change_summary) form.append('change_summary', input.change_summary);
  // Text fields before the file, the conventional order for multer.
  form.append('file', input.file);
  const res = await api.post<PublishAgreementResult>('/admin/agreements', form, {
    // A 10 MB PDF on a slow connection can outlast the default 30 s.
    timeout: 120_000,
  });
  return res.data;
}

export async function fetch_agreement_versions(
  module_type: VendorModuleType,
): Promise<AgreementVersionWithCount[]> {
  const res = await api.get<AgreementVersionWithCount[]>(
    `/admin/agreements/modules/${module_type}/versions`,
  );
  return res.data;
}

export async function fetch_agreement_vendors(id: string): Promise<AgreementVendorStatus[]> {
  const res = await api.get<AgreementVendorStatus[]>(`/admin/agreements/${id}/vendors`);
  return res.data;
}
